<template>
<div id="avtoservis">
    <link rel="stylesheet" href="/static/css/general/avtoservice.css">
    <section class="section2">
        <div class="section2_con1">
            <div class="section2_left">
                <div :style="{width: '410px',height: '310px',backgroundImage: 'url(' + property.photo +')', backgroundRepeat: 'no-repeat', backgroundPosition: 'top center',backgroundSize: 'contain'}"></div>
            </div>
            <div class="section2_right">
                <div class="section2_right_cont">
                    <div class="section2_right_text">
                        <div class="section2_right_text_pos">
                            <p class="section2_right_text_am">
                                {{avtoservice.name}}
                            </p>
                            <div class="stars_pos">
                                <img :src="property.rating > 0 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg'">
                                <img :src="property.rating > 20 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg'">
                                <img :src="property.rating > 40 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg'">
                                <img :src="property.rating > 60 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg'">
                                <img :src="property.rating > 80 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg'">
                            </div>
                        </div>
                        <div class="section2_right_text_ad">
                            {{property.address}}
                        </div>
                        <div class="section2_right_images">
                            <i v-if="property.parking === '1'" class="fas fa-parking col-sm-10"></i>
                            <i v-if="property.tv === '1'" class="fas fa-tv col-sm-10"></i>
                            <i v-if="property.coffe === '1'" class="fas fa-coffee col-sm-10"></i>
                            <i v-if="property.wifi === '1'" class="fas fa-wifi col-sm-10"></i>
                            <i v-if="property.card === '1'" class="fas fa-credit-card col-sm-10"></i>
                            <i v-if="property.bonusin === '1' || property.bonus === '1'" class="fas fa-gift col-sm-10"></i>
                        </div>
                    </div>
                </div>
                <div class="section2_right_under_text">
                    <div class="justline"></div>
                    <div class="section2_right_under_text1">{{avtoservice.description}}</div>
                </div>
            </div>

        </div>
    </section >
    <section class="section3">
        <index-form :user.sync="user" :city.sync="city" :auth.sync="auth" :service.sync="avtoservice.id"/>
    </section>
    <section class="section4">
        <div class="section4_pos">
            <div class="section4_title">
                <p class="section4_title1">Отзывы {{avtoservice.name}}</p>
                <div class="section4_text2" :key="review.id" v-for="review in reviews">
                    <div class="section4_text2_l">
                        <div class="section4_text2_who">
                            {{review.name}}
                        </div>
                        <div class="section4_text2_l_s">
                            <img :src="[ review.stars > 0 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg']">
                            <img :src="[ review.stars > 1 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg']">
                            <img :src="[ review.stars > 2 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg']">
                            <img :src="[ review.stars > 3 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg']">
                            <img :src="[ review.stars > 4 ? '/static/uploads/2018/09/20/22/50/img2/s1w.svg' : '/static/uploads/2018/09/20/22/50/img2/s2w.svg']">
                        </div>
                    </div>
                    <div class="section4_text2_car_and_data">
                        <div class="section4_text2_car">
                            {{review.mark}} {{review.model}}
                        </div>
                        <div class="section4_text2_data">
                            {{review.created_at}}
                        </div>
                    </div>
                    <div class="section4_text2_cont">
                        {{review.text}}
                    </div>
                </div>
                <div class="section4_text2" v-if="!reviews.length">
                    Пока еще никто не оставил отзыв
                </div>
            </div>
            <div>
                <div class="section4_grid">
                    <div class="field">
                        <div class="field" id="application-brand-fields">
                            <select id="order-form-marks" title="Марка" required name="mark" class="select2"></select>
                        </div>
                    </div>
                    <div class="field middle_field">
                        <div class="field select-models">
                            <select id="order-form-models" title="Модель" required name="model" disabled class="select2"></select>
                        </div>
                    </div>
                    <div class="field">
                        <input type="text" name="name" placeholder="Ваше имя" v-model="user.name" class="">
                    </div>
                    <div class="section4_grid_sta">
                        <fieldset>
                          <span class="star-cb-group">
                            <input type="radio" id="rating-5" name="stars" v-model="star" value="5" /><label for="rating-5">5</label>
                            <input type="radio" id="rating-4" name="stars" v-model="star" value="4" /><label for="rating-4">4</label>
                            <input type="radio" id="rating-3" name="stars" v-model="star" value="3" /><label for="rating-3">3</label>
                            <input type="radio" id="rating-2" name="stars" v-model="star" value="2" /><label for="rating-2">2</label>
                            <input type="radio" id="rating-1" name="stars" v-model="star" value="1" /><label for="rating-1">1</label>
                            <input type="radio" id="rating-0" name="stars" v-model="star" value="0" checked="checked" class="star-cb-clear" /><label for="rating-0">0</label>
                          </span>
                        </fieldset>
                    </div>
                    <textarea placeholder="Введите отзыв" class="form-control col-lg-120 " v-model="text" name="text" required></textarea>
                    <div class="get-offer"> <button type="submit" @click="sendRes">Разместить</button></div>
                </div>
                <br>
            </div>
        </div>
    </section>
    <section class="section5">
        <div class="section5_pos">
            <reviews/>
        </div>
    </section>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
export default {
  name: 'Avtoservis',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      avtoservice: {},
      property: {},
      reviews: [],
      brands: [],
      marks: [],
      mark: null,
      model: null,
      star: 0,
      text: null
    }
  },
  created () {
    var id = this.$route.params.id
    axios.get('https://crm.v-avtoservice.com/list/site-get-service?id=' + id + '&lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
      this.avtoservice = response.data.avtoservice
      this.property = response.data.property
      this.reviews = response.data.reviews
    })
  },
  watch: {
    $route (to, from) {
      var id = to.params.id
      axios.get('https://crm.v-avtoservice.com/list/site-get-service?id=' + id + '&lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
        this.avtoservice = response.data.avtoservice
        this.property = response.data.property
        this.reviews = response.data.reviews
      })
    }
  },
  mounted () {
    var $this = this
    $('#order-form-marks').select2({
      placeholder: 'Выберите Марку',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-marks',
        dataType: 'json',
        processResults: function (data) {
          let res = $.map(data, function (item) {
            $this.brands[item.id] = item.name
            return {
              text: item.name,
              id: item.id
            }
          })
          return {
            results: res
          }
        }
      }
    }).change(function (data) {
      $this.mark = $(this).val()
      $('#order-form-models').val(null).trigger('change').prop('disabled', false)
    })

    $('#order-form-models').select2({
      placeholder: 'Выберите Модель',
      ajax: {
        delay: 250,
        type: 'POST',
        data: function (params) {
          params.brend_id = $this.mark
          params.q = params.term
          return params
        },
        url: 'https://crm.v-avtoservice.com/list/site-get-models',
        dataType: 'json',
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.marks[item.id] = item.name
              return {
                text: item.name,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.model = $(this).val()
    })
  },
  methods: {
    sendRes () {
      if (!this.user.name) alert('Вам необходимо указать имя')
      else if (!this.text) alert('Вам необходимо указать текст отзыва')
      else if (!this.mark && !this.model) alert('Вам необходимо указать марку и модель авто')
      else {
        setTimeout(function () { alert('Спасибо, Ваш отзыв отправлен') }, 1)
        var formData = new FormData()
        formData.append('service', this.avtoservice.id)
        formData.append('uid', this.user.uid)
        formData.append('name', this.user.name)
        formData.append('text', this.text)
        formData.append('mark', this.brands[this.mark])
        formData.append('model', this.marks[this.model])
        formData.append('star', this.star)
        axios.post('https://crm.v-avtoservice.com/list/send-review',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>
    .calculation {
        display: none;
    }
    .section5 .slick-slider {
        position: relative;
    }
    .section5 .slider-responsive .slick-prev {
        left: -15px;
    }
    .section5 .slider-responsive .slick-next {
        right: -15px;
    }
    #select-add-field .select2-container--default .select2-selection--single {
        border: 1px solid #3290d0;
    }

    #select-add-field .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #3290d0;
    }

    #select-add-field .select2-selection__arrow:before {
        content: '+';
        color: #3290d0;
        display: block;
        width: 30px;
        height: 26px;
        background: #fff;
        padding: 0 0 0 8px;
        line-height: 26px;
        z-index: 111111;
        position: absolute;
        font-size: 24px;
        margin: 6px 0 0 -14px;
        border-left: 1px solid #d4d4d4;
    }
     .ml10 {
         margin-left: 10px;
     }
    .padlr0 {
        padding-left: 0px;
        padding-right: 0px;
    }

    .hreg {
        height: 600px;
    }

    .map {
        width: 100%;
        margin: 35px auto;
        background: #999;
    }

    .scroll {
        overflow-y: scroll;
    }

    .olaha {

    }

    .name {
        color: #000;
    }

    .gm-style-iw > div > div {
        overflow: hidden !important;
    }

    .gm-style-iw > div {
        overflow: hidden !important;
        width: 500px;
        margin-left: 5px;
        /*height: 120px;*/
    }

    .gm-style-iw img {
        width: 100%;
        /*margin-left: 10px;*/
        height: 120px;
    }

    .ml-25 {
        margin-left: -25px;
    }

    .gm-style-iw h3 {
        padding: 10px 10px 10px 0;
        margin: 0 0 0 10px;
        text-decoration: none;
    }

    .gm-style-iw p {
        padding: 0;
        margin: 10px 0 0 10px;
    }

    .page-numbers {
        padding-top: 11px;
        list-style: none;
        display: -moz-inline-stack;
        display: inline-block;
        vertical-align: middle;
        zoom: 1;
        width: 46px;
        height: 46px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        -ms-border-radius: 5px;
        -o-border-radius: 5px;
        border-radius: 5px;
        border: 1px solid rgba(67, 72, 76, .16);
        margin: 8px 8px 8px 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        color: #212121;
        text-decoration: none;
    }

    a.page-numbers:not(.disabled):hover {
        border-color: #f95c3c;
        text-decoration: none;
    }

    span.page-numbers.current {
        padding-top: 0;
        border: 2px solid rgba(249, 92, 60, .5);
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        -ms-border-radius: 4px;
        -o-border-radius: 4px;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 40px;
    }

    .mtitle {
        font-size: 23px;
        font-weight: 600;
        color: black;
    }

    .m-text {
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Avtoservis.vue